export enum DiscountTypeEnum {
  /** 無優待 */
  NoDiscount = 0,
  /** 折扣百分比 */
  DiscountPercent = 1,
  /** 折扣金額 */
  DiscountAmount = 2,
  /** 加成百分比 */
  AdditionPercent = 3,
  /** 加成金額 */
  AdditionAmount = 4,
  /** 固定金額 */
  FixedAmount = 5,
}
